var _rect, _rect2, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCheckNewBlue = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65.625,
    height: 65.625,
    rx: 6.5625,
    fill: "#EBF2FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1772_551",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 40,
    height: 40
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.125,
    y: 13.125,
    width: 39.375,
    height: 39.375,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1772_551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8125 45.9375C29.1484 45.9375 26.0449 44.666 23.502 42.123C20.959 39.5801 19.6875 36.4766 19.6875 32.8125C19.6875 29.1484 20.959 26.0449 23.502 23.502C26.0449 20.959 29.1484 19.6875 32.8125 19.6875C34.6992 19.6875 36.5039 20.0771 38.2266 20.8564C39.9492 21.6357 41.4258 22.75 42.6562 24.1992V19.6875H45.9375V31.1719H34.4531V27.8906H41.3438C40.4688 26.3594 39.2725 25.1562 37.7549 24.2812C36.2373 23.4062 34.5898 22.9688 32.8125 22.9688C30.0781 22.9688 27.7539 23.9258 25.8398 25.8398C23.9258 27.7539 22.9688 30.0781 22.9688 32.8125C22.9688 35.5469 23.9258 37.8711 25.8398 39.7852C27.7539 41.6992 30.0781 42.6562 32.8125 42.6562C34.918 42.6562 36.8184 42.0547 38.5137 40.8516C40.209 39.6484 41.3984 38.0625 42.082 36.0938H45.5273C44.7617 38.9922 43.2031 41.3574 40.8516 43.1895C38.5 45.0215 35.8203 45.9375 32.8125 45.9375Z",
    fill: "#455CC7"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckNewBlue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check-new-blue.abfb4ae7.svg";
export { ForwardRef as ReactComponent };